import React from 'react';
interface FramedPortraitProps {
  src: string;
  alt: string;
  className?: string;
}
export function FramedPortrait({
  src,
  alt,
  className = ''
}: FramedPortraitProps) {
  return <div className={`inline-flex items-center justify-center rounded-full bg-white p-2.5 shadow-card ring-1 ring-slate-200 ${className}`} data-id="element-184" data-mp="2epb6hjt0e88p">
      <div className="rounded-full border-2 border-slate-300 p-1.5" data-id="element-185" data-mp="2jmjsxwl6wyfr">
        <div className="rounded-full border border-brandgreen/40 p-1" data-id="element-186" data-mp="25o3jvyzuuvug">
          <img src={src} alt={alt} className="h-40 w-40 rounded-full object-cover sm:h-48 sm:w-48" data-id="element-187" data-mp="2an6gqw5olvrc" />
        </div>
      </div>
    </div>;
}